import React from "react";
import { StyleSheet, Text, View } from "@react-pdf/renderer";

const Td = ({
  isLeft,
  newPageFirst,
  text,
  fontSize,
  children,
  trWidth,
  withWeight,
  index,
  breakArray,
}) => {
  const styles = StyleSheet.create({
    td: {
      display: "flex",
      fontSize: fontSize,
      width: `${trWidth * withWeight}%`,
      border: "1px solid black",
      borderLeft: isLeft ? "1px solid black" : "none",
      borderTop: newPageFirst ? "1px solid black" : "none",
      padding: "4px 3px",
      textAlign: "center",
    },
    font: {
      fontFamily: "NotoSansTC",
    },
  });
  return (
    <View
      style={[
        styles.td,
        breakArray
          ? index !== 0 && (index - breakArray[0]) % breakArray[1] === 0
            ? { borderTop: "1px solid black" }
            : {}
          : {},
      ]}
    >
      {children ? children : <Text style={[styles.font]}>{text}</Text>}
    </View>
  );
};

export default Td;
